const debounce = <T extends (...args: any[]) => any>(
  callback: T,
  waitTimeInMs: number
) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback(...args), waitTimeInMs);
  };
};

export default debounce;
